module.exports = __webpack_public_path__ + "img/nav-logo.0f252462.png";